import { Button } from '@mui/material';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import { ACTION_BUTTON_HEIGHT, ghostButtonSX } from '../scriptsStyles';

interface DownloadButtonProps {
  onClick: () => void;
  disabled?: boolean;
}

export const DownloadButton = ({ onClick, disabled }: DownloadButtonProps) => {
  return (
    <Button
      onClick={onClick}
      disabled={disabled}
      startIcon={<FileDownloadOutlinedIcon />}
      sx={{ ...ghostButtonSX, height: ACTION_BUTTON_HEIGHT, px: 1.5 }}
    >
      Exportar
    </Button>
  );
};
